import React from 'react';
import { WHEELCHAIR_INTRO, WHEELCHAIR_LONG_TAIL } from './wheelchairLongTailI18n';

// Renders the rich wheelchair long-tail content block (intro + Q&A as H3/answer)
// for SEO + GEO. The same Q&As are also injected into the FAQPage JSON-LD on the
// equipment page, so both Google rich results and AI assistants can cite them.
export default function WheelchairLongTailSection({ lang = 'pt' }) {
  const block = WHEELCHAIR_INTRO[lang] || WHEELCHAIR_INTRO.pt;
  const items = WHEELCHAIR_LONG_TAIL[lang] || WHEELCHAIR_LONG_TAIL.pt;
  return (
    <section className="py-10 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-4">{block.head}</h2>
        <p className="text-slate-700 text-base leading-relaxed mb-8">{block.intro}</p>
        <div className="space-y-6">
          {items.map((it, i) => (
            <div key={i}>
              <h3 className="text-lg font-semibold text-slate-800 mb-2">{it.q}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{it.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}